export const MAPBOX_TOKEN =
    "pk.eyJ1IjoicGFyYXBvbG8iLCJhIjoiY204ZnJ6ZHp2MGh5ODJqc2RiMWp6N3NwdiJ9.vAuv-yqPVwaDu_qRW6Q1eg";
